(function () {
  if (window.MagazineHeaderNavigation) {
    window.MagazineHeaderNavigation.init(document);
    return;
  }

  function archiveUrl(filter) {
    const url = new URL(filter.dataset.magArchiveUrl, window.location.origin);
    const current = new URL(window.location.href);
    ['preview_theme_id', 'preview_key', '_fd', 'pb', 'locale', 'country', 'language'].forEach((key) => {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    return url;
  }

  function closeAll(except, restoreFocus = false) {
    document.querySelectorAll('[data-mag-header-filter][open]').forEach((filter) => {
      if (filter === except) return;
      const focusInside = filter.contains(document.activeElement);
      filter.open = false;
      if (restoreFocus && focusInside) filter.querySelector('[data-mag-header-toggle]')?.focus();
    });
  }

  function init(root) {
    root.querySelectorAll('[data-mag-header-filter]').forEach((filter) => {
      if (filter.dataset.magHeaderInitialized === 'true') return;
      filter.dataset.magHeaderInitialized = 'true';

      const toggle = filter.querySelector('[data-mag-header-toggle]');
      const list = filter.querySelector('[data-mag-header-categories]');
      const status = filter.querySelector('[data-mag-header-status]');
      const retry = filter.querySelector('[data-mag-header-retry]');
      const allLink = filter.querySelector('[data-mag-header-all]');
      const url = archiveUrl(filter);
      let loading = false;
      let loaded = false;

      allLink.href = url.toString();

      async function loadCategories() {
        if (loading || loaded) return;
        loading = true;
        list.setAttribute('aria-busy', 'true');
        status.textContent = filter.dataset.loadingLabel;
        status.hidden = false;
        retry.hidden = true;

        try {
          if (!window.MagazineArchive) throw new Error('Magazine archive is unavailable.');
          const records = await window.MagazineArchive.load({
            url: url.toString(),
          });
          const categories = new Map();
          records.forEach((record) => {
            record.categories.forEach((label, index) => {
              const key = record.categoryKeys[index] || label.trim().toLowerCase();
              if (key && !categories.has(key)) categories.set(key, label);
            });
          });

          [...categories.entries()]
            .sort((left, right) =>
              left[1].localeCompare(right[1], undefined, {
                sensitivity: 'base',
              }),
            )
            .forEach(([key, label]) => {
              const categoryUrl = new URL(url);
              categoryUrl.searchParams.set('category', key);
              const item = document.createElement('li');
              item.className = 'mag-header__filter-item';
              const link = document.createElement('a');
              link.className = 'mag-header__filter-link';
              link.href = categoryUrl.toString();
              link.textContent = label;
              item.appendChild(link);
              list.appendChild(item);
            });

          loaded = true;
          status.textContent = '';
          status.hidden = true;
        } catch (error) {
          status.textContent = filter.dataset.errorLabel;
          retry.hidden = false;
        } finally {
          loading = false;
          list.removeAttribute('aria-busy');
        }
      }

      filter.addEventListener('toggle', () => {
        filter.classList.toggle('is-open', filter.open);
        toggle.setAttribute('aria-expanded', String(filter.open));
        if (filter.open) {
          closeAll(filter);
          loadCategories();
        }
      });
      retry.addEventListener('click', loadCategories);

      if (filter.open) loadCategories();
    });
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-mag-header-filter]')) closeAll(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.querySelector('[data-mag-header-filter][open]')) {
      event.preventDefault();
      closeAll(null, true);
    }
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.MagazineHeaderNavigation = { init };
  init(document);
})();
